import React from 'react'
import { Shield, WifiOff } from 'react-feather'

const BlockedScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center">
            <Shield size={40} className="text-red-400" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-white">Access Restricted</h1>
          <p className="text-gray-400">
            You are attempting to access Intellasure from outside the office network.
          </p>
        </div>

        <div className="bg-dark-card border border-dark-border rounded-xl p-4 space-y-3">
          <div className="flex items-center gap-3">
            <WifiOff size={18} className="text-gray-500 flex-shrink-0" />
            <p className="text-sm text-gray-300 text-left">
              Your current network is not authorized. Please connect to the office network or contact your administrator to enable remote access.
            </p>
          </div>
        </div>

        <button
          onClick={() => window.location.reload()}
          className="px-6 py-2.5 bg-dark-card border border-dark-border rounded-xl text-sm text-gray-300 hover:text-white hover:border-gray-500 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  )
}

export default BlockedScreen
